import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import * as Styled from './styled';

function TripOptionsTabs({ itineraries, activeItinerary, setActiveItinerary }) {
  return (
    <Styled.TripOptionTabsWrapper>
      <Styled.TripOptionsSelectorRow>
        {itineraries.map(it => (
          <Styled.TripOptionButton
            key={it.id}
            onClick={() => setActiveItinerary(it.id)}
            isActive={activeItinerary.id === it.id}
            optionId={it.id}
          >
            <FormattedMessage
              id="planner.tripoptionid"
              values={{ id: it.id }}
            />
          </Styled.TripOptionButton>
        ))}
      </Styled.TripOptionsSelectorRow>
    </Styled.TripOptionTabsWrapper>
  );
}

TripOptionsTabs.propTypes = {
  /** Array of itineraries that were generated based on Trip Parameters */
  itineraries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    })
  ).isRequired,
  /** Itinerary that the user has selected to view, contains multiple legs */
  activeItinerary: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  /** When clicked, causes the selected Itinerary to be Active */
  setActiveItinerary: PropTypes.func.isRequired,
};
export default TripOptionsTabs;
